import { CatalogoService } from '../../_services/catalogo.service';
import { Traducible } from './traducible';
import { Catalogo } from '../catalogo';
import { TmmvMinimalNode } from '../arbol-lazy/tmmv-minimal-node';
import { TmmvNodo } from './tmmv-nodo';
export class Version {
	constructor(params = undefined) {
		if (params) {
			this.idVersion = params.idVersion;
			this.idVersionPadre = params.idVersionPadre;
			this.idCliente = params.idCliente;
			this.nombreDescripcion = params.nombreDescripcion;
			this.vigenciaDesde = params.vigenciaDesde;
			this.vigenciaHasta = params.vigenciaHasta;
			this.activo = params.activo;
			this.valoresAtributos = params.valoresAtributos;
			this.codigos = params.codigos;
			this.variables = params.variables;
			this.segmentos = params.segmentos;
			this.fotografias = params.fotografias;
			this.modelo = params.modelo;
			this.atributos = params.atributos;
			this.formulas = params.formulas;
			this.padre = params.padre;
			this.patsDisplay = params.patsDisplay;
			this.migraNyvus = params.migraNyvus;
			this.migraConducelo = params.migraConducelo;
			this.idNyvus = params.idNyvus;
			this.nombreDesTraducible = params.nombreDesTraducible;
			this.catalogo = params.catalogo;
			this.tieneEquipo = params.tieneEquipo;
			this.tienePrecio = params.tienePrecio;
			this.idVarianteReferencia = params.idVarianteReferencia;
		}
	}
	catalogo: Catalogo;
	idVersion: number;
	idVersionPadre: number;
	idCliente: number;
	nombreDescripcion: string;
	vigenciaDesde: any;
	vigenciaHasta: any;
	activo: boolean = true;
	valoresAtributos: any[] = [];
	codigos: any[] = [];
	variables: Array<any> = [];
	segmentos: any[] = [];
	fotografias: any[] = [];
	modelo: any;
	atributos: any[] = [];
	formulas: any[] = [];
	padre: Version;
	patsDisplay: any[] = [];
	migraNyvus: boolean = true;
	migraConducelo: boolean;
	idNyvus: number;
	nombreDesTraducible: Traducible;
	fechaUltimoPrecio: any;
	tieneEquipo: boolean;
	tienePrecio: boolean;
	idVarianteReferencia: number;
	esVersionParcial: boolean;

	crearDesdeTmmMinimal(nodo: TmmvMinimalNode) {
        if (!nodo) return;
		this.idVersion = nodo.id;
		this.esVersionParcial = Boolean(nodo.p);
        this.modelo = new TmmvNodo();
        this.modelo.crearDesdeTmmMinimal(nodo.padre);
    }
}
